import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import { vMaska } from 'maska/vue'
import './assets/tailwind.css'
import router from './router'
import store from './store'
import Swal from 'sweetalert2';

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(store)
app.use(vuetify)
app.use(router)
app.directive('maska', vMaska)
app.config.globalProperties.$swal = Swal;

axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('setToken')
            localStorage.removeItem('setUser')
            localStorage.removeItem('userData')
            router.push('/')
        }
        return Promise.reject(error)
    }
)

store.dispatch('initializeStore')

app.mount('#app')
